<template>
	<div class="case-download card">
		<div class="header4">Download</div>
		<div>
			<DownloadItem
				v-for="document in documents"
				v-bind:key="document.id"
				:title="document.name"
				:isSigned="document.isSigned"
				type="PFD"
				:href="document.url"
			/>
		</div>
		<div class="all-files">
			<div class="header5">View all</div>
		</div>
	</div>
</template>

<script>
import DownloadItem from "@/components/case/DownloadItem.vue";

export default {
	name: "case-download",
	components: {
		DownloadItem,
	},
	props: {
		id: Number,
		documents: [],
	},
	data() {
		return {
			date: new Date(),
		};
	},
};
</script>

<style scoped lang="scss">
.case-download {
	padding: 25px;
	text-align: left;
	display: flex;
	flex-direction: column;
	.all-files {
		border-top: 2px solid #f4f4f4;
		margin-top: 45px;
		padding-top: 30px;
		text-align: center;
		.header5 {
			color: var(--dark-gray);
		}
	}
	.header4 {
		color: var(--dark-gray);
		margin-bottom: 30px;
	}
	.paragraph {
		color: var(--dark-gray);
		margin-top: 15px;
		opacity: 0.5;
	}
	.download-item {
		// padding-bottom: 40px;
		float: left;
		width: 100%;
		position: relative;
	}
	.download-item:before {
		content: "";
		position: absolute;
		top: 86px;
		width: 1px;
		height: 28%;
		left: 22px;
		background: var(--text);
		// z-index: -1;
	}
	.download-item:last-child:before {
		display: none;
	}
}
</style>
